import { useMemo } from "react";
import { Gift, CreditCard, Ticket, Percent, Tag, Zap, Wallet, Star } from "lucide-react";

const icons = [Gift, CreditCard, Ticket, Percent, Tag, Zap, Wallet, Star];

export default function FloatingIcons({ count = 18 }: { count?: number }) {
  const items = useMemo(() =>
    Array.from({ length: count }, (_, i) => ({
      Icon: icons[i % icons.length],
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: 16 + Math.random() * 20,
      delay: Math.random() * 8,
      duration: 12 + Math.random() * 10,
      rotation: Math.random() * 360,
    })),
  [count]);

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden>
      {items.map((item, i) => (
        <div
          key={i}
          className="absolute animate-[floatIcon_var(--dur)_ease-in-out_infinite_var(--delay)]"
          style={{
            left: `${item.x}%`,
            top: `${item.y}%`,
            "--dur": `${item.duration}s`,
            "--delay": `-${item.delay}s`,
            transform: `rotate(${item.rotation}deg)`,
          } as React.CSSProperties}
        >
          <item.Icon
            className="text-foreground/20 dark:text-foreground/20"
            style={{ width: item.size, height: item.size }}
          />
        </div>
      ))}
    </div>
  );
}
